import React, { useEffect, useState, createElement } from 'react';
import { Header } from '../components/heylloyd/Header';
import { StepSection } from '../components/heylloyd/StepSection';
import { LloydCard } from '../components/heylloyd/LloydCard';
import { DecisionGuide } from '../components/heylloyd/DecisionGuide';
import { SundayCountdownTimer } from '../components/SundayCountdownTimer';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { ShoppingCart, Monitor, Bot, Check, X, Zap, Clock, Rocket, ChevronDown, Users, Video, Calendar } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
export function WebinarReplyPage() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(null);
  const toggleFaq = (index: number) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };
  useEffect(() => {
    // Load Wistia scripts immediately for instant video playback
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/zp6fg5q0oy.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(embedScript);
    const style = document.createElement('style');
    style.textContent = `
      wistia-player[media-id='zp6fg5q0oy']:not(:defined) { 
        background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/zp6fg5q0oy/swatch'); 
        display: block; 
        filter: blur(5px); 
        padding-top:56.25%; 
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(playerScript);
      document.head.removeChild(embedScript);
      document.head.removeChild(style);
    };
  }, []);
  const faqs = [{
    question: '¿Qué incluye exactamente 48/hrs AI Cash Machine?',
    answer: 'Obtienes acceso instantáneo a todos los Custom Lloyds especializados y el sistema paso a paso completo. Además, recibirás guías detalladas, acceso al grupo privado de Facebook, y llamadas mensuales en vivo con Gabriel Beltran. Nota: HeyLloyd es un software mensual separado ($20/mes con plan anual o $40/mes con plan mensual) que necesitarás para usar los Custom Lloyds.'
  }, {
    question: '¿Realmente puedo crear un producto en 48 horas sin experiencia?',
    answer: 'Sí. Los Custom Lloyds te guían paso a paso en cada tarea. No necesitas conocimientos técnicos, de diseño o marketing. El sistema te dice exactamente qué hacer en cada momento, eliminando la curva de aprendizaje.'
  }, {
    question: '¿Qué es el grupo privado de Facebook?',
    answer: 'Es una comunidad exclusiva para miembros de 48/hrs AI Cash Machine donde puedes conectar con otros emprendedores, compartir experiencias, hacer preguntas y recibir apoyo constante en tu proceso de creación y lanzamiento.'
  }, {
    question: '¿Cómo funcionan las llamadas mensuales con Gabriel Beltran?',
    answer: 'Cada mes, un lunes, Gabriel Beltran realiza una llamada en vivo exclusiva para miembros donde responde preguntas, comparte estrategias actualizadas y te ayuda a escalar tu negocio. Estas sesiones son grabadas por si no puedes asistir en vivo.'
  }, {
    question: '¿Qué pasa si no completo todo en 48 horas?',
    answer: 'No hay problema. 48 horas es el tiempo estimado siguiendo el sistema paso a paso, pero tienes acceso de por vida a todos los Custom Lloyds y recursos. Puedes ir a tu propio ritmo.'
  }, {
    question: '¿Necesito pagar por HeyLloyd por separado?',
    answer: 'Sí, HeyLloyd es un software mensual que se paga por separado. Cuesta $20/mes si pagas anualmente o $40/mes si pagas mensualmente. HeyLloyd es la plataforma que ejecuta los Custom Lloyds en tu computadora. Los Custom Lloyds especializados están incluidos en 48/hrs AI Cash Machine.'
  }, {
    question: '¿Funciona en Mac y Windows?',
    answer: 'Sí, HeyLloyd funciona tanto en Mac como en Windows. El sistema se adapta a tu computadora y funciona de la misma manera en ambas plataformas.'
  }, {
    question: '¿Hay garantía de devolución?',
    answer: 'Sí, ofrecemos una garantía de satisfacción de 30 días. Si no estás satisfecho con el producto, puedes solicitar un reembolso completo dentro de los primeros 30 días.'
  }];
  return <div className="min-h-screen bg-black text-white font-sans" data-id="element-5855" data-mp="d0ocapd5eamn">
      <Header data-id="element-5856" data-mp="d2hlabb8h6xt" />

      {/* Hero Section - Webinar Replay with Video */}
      <section className="pt-14 md:pt-16 py-6 md:py-10 bg-gradient-to-b from-gray-900 to-black" data-id="element-5857" data-mp="h2rppjjdnpak">
        <div className="container mx-auto px-4 max-w-5xl" data-id="element-5858" data-mp="27fqvk5blswh4">
          {/* Replay Badge */}
          <div className="text-center mb-5" data-id="element-5859" data-mp="2bezqvemal2es"></div>

          {/* Headline */}
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-black text-white mb-3 md:mb-5 leading-tight text-center tracking-tight" data-id="element-5860" data-mp="3vxk16y4kj5nr">
            48/hrs AI Cash Machine
          </h1>

          <p className="text-base md:text-lg text-gray-100 mb-5 md:mb-7 max-w-3xl mx-auto leading-relaxed text-center" data-id="element-5861" data-mp="9i7dbsp92mvg">
            El sistema completo que te guía paso a paso para crear y lanzar tu
            producto digital con IA en menos de 48 horas
          </p>

          {/* Video Player */}
          <div className="mb-8 md:mb-10" data-id="element-5862" data-mp="ehtyqpf8f9fc">
            <div className="w-full max-w-4xl mx-auto overflow-hidden border border-cyan-500 relative" style={{
            boxShadow: '0 0 40px rgba(6, 182, 212, 0.4), 0 0 80px rgba(6, 182, 212, 0.2)'
          }} data-id="element-5863" data-mp="eh253k573lrp">
              <wistia-player media-id="zp6fg5q0oy" aspect="1.7777777777777777" data-id="element-5864" data-mp="nj1q0njbz9zx"></wistia-player>
            </div>
          </div>

          {/* CTA Button */}
          <div className="text-center mb-8" data-id="element-5865" data-mp="2paesl5xtt5st">
            <a href="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" target="_blank" rel="noopener noreferrer" data-id="element-5866" data-mp="2pbput1bmi5ht">
              <Button variant="cyan" size="lg" className="w-full md:w-auto shadow-2xl text-lg md:text-xl py-5 md:py-6 px-8 md:px-12" leftIcon={<ShoppingCart className="w-6 h-6" data-id="element-5868" data-mp="133le8ii4rjea" />} data-id="element-5867" data-mp="y5bio6shugs5">
                Comprar Ahora - Acceso Inmediato
              </Button>
            </a>
          </div>

          {/* Countdown Timer */}
          <div className="max-w-2xl mx-auto" data-id="element-5869" data-mp="1c64f4x2cvlxw">
            <SundayCountdownTimer data-id="element-5870" data-mp="1c52txzrmlj2g" />
          </div>
        </div>
      </section>

      {/* Value Proposition Section */}
      <section className="py-10 md:py-14 bg-black" data-id="element-5871" data-mp="1lv5tyjx5zxaa">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-5872" data-mp="1lwgvse71uuyr">
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl shadow-2xl p-5 md:p-8 border border-gray-700" data-id="element-5873" data-mp="1qtz7udgd5qaz">
            <div className="flex items-center justify-center gap-3 mb-3" data-id="element-5874" data-mp="1uwvjfk7hkm5f">
              <Zap className="w-7 h-7 md:w-9 md:h-9 text-yellow-500" data-id="element-5875" data-mp="1zudvvkkppji6" />
              <h3 className="text-xl md:text-2xl font-bold text-white" data-id="element-5876" data-mp="1zskn9zqjgp7j">
                Incluso si no tienes experiencia
              </h3>
            </div>
            <p className="text-base md:text-lg text-gray-100 text-center leading-relaxed" data-id="element-5877" data-mp="3fd3ewzfawv5k">
              El sistema paso a paso con Custom Lloyds especializados te guiará
              en cada paso del proceso para que puedas estar en vivo en 48 horas
              o menos
            </p>
          </div>
        </div>
      </section>

      {/* PASO 1 */}
      <div id="paso-1" data-id="element-5878" data-mp="2wg8jlnyvusz">
        <StepSection stepNumber="1" title="Obtén acceso inmediato a todos los Custom Lloyds" data-id="element-5879" data-mp="2w7vntrugphs">
          <p className="text-lg md:text-xl text-gray-400 mb-6 md:mb-8" data-id="element-5880" data-mp="3uam4g3zszce2">
            Al adquirir 48/hrs AI Cash Machine, obtendrás acceso instantáneo a
            todos los Custom Lloyds especializados y el sistema paso a paso
            completo que te guiará en cada etapa.
          </p>

          <div className="mb-8 md:mb-10" data-id="element-5881" data-mp="lusllii01otu">
            <a href="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" target="_blank" rel="noopener noreferrer" data-id="element-5882" data-mp="ltrbbg8t56d6">
              <Button variant="cyan" size="lg" className="w-full md:w-auto shadow-lg hover:shadow-xl" leftIcon={<ShoppingCart className="w-5 h-5" data-id="element-5884" data-mp="3v5omnpkwcyf2" />} data-id="element-5883" data-mp="3qbbyj28h6ywz">
                Comprar Ahora - Acceso Inmediato
              </Button>
            </a>
          </div>

          <div className="bg-gradient-to-r from-cyan-900 to-blue-900 rounded-xl p-6 md:p-8 border border-cyan-700 mb-6" data-id="element-5885" data-mp="3lf3mvythlnuk">
            <h4 className="font-bold text-white mb-4 text-lg flex items-center gap-2" data-id="element-5886" data-mp="cz1v1wiolf4f">
              <Rocket className="w-6 h-6 text-cyan-400" data-id="element-5887" data-mp="hwtm6obi4x7k" />
              Lo que obtienes inmediatamente:
            </h4>
            <div className="space-y-3" data-id="element-5888" data-mp="3zn7b4twfinm">
              {['Acceso instantáneo a todos los Custom Lloyds especializados', 'Sistema paso a paso completo para crear tu producto', 'Guías detalladas para cada etapa del proceso', 'Acceso al grupo privado de Facebook', 'Llamadas mensuales en vivo con Gabriel Beltran', 'Soporte prioritario para implementación'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-5889" data-mp="2l4ua9wuh4pew" data-mpi={i}>
                  <Check className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" data-id="element-5890" data-mp="2g6sp96dhmg0s" />
                  <span className="text-gray-200" data-id="element-5891" data-mp="2g9577jj8wqdu">{item}</span>
                </div>)}
            </div>
          </div>

          <div className="bg-cyan-900/70 border border-cyan-500 rounded-xl p-4 md:p-6" data-id="element-5892" data-mp="2q4yqdlrgzi4l">
            <p className="text-white text-sm md:text-base" data-id="element-5893" data-mp="2q34340sq7dxc">
              <strong className="text-cyan-100" data-id="element-5894" data-mp="22fw1bsuian02">Nota importante:</strong> Para
              usar los Custom Lloyds, necesitarás HeyLloyd, un software mensual
              que se paga por separado ($20/mes con plan anual o $40/mes con
              plan mensual). HeyLloyd es la plataforma que ejecuta los Custom
              Lloyds en tu computadora.
            </p>
          </div>
        </StepSection>
      </div>

      {/* PASO 2 */}
      <div id="paso-2" data-id="element-5895" data-mp="1jmjusfl614u9">
        <StepSection stepNumber="2" title="Usa HeyLloyd para ejecutar los Custom Lloyds" bgColor="gray" data-id="element-5896" data-mp="1eqbjjda39vsd">
          <p className="text-lg md:text-xl text-slate-800 mb-4 md:mb-6" data-id="element-5897" data-mp="21bx3yyedilwo">
            HeyLloyd es el software que ejecuta los Custom Lloyds. Es una
            superposición de escritorio transparente que se coloca sobre tu
            pantalla y te guía en tiempo real:
          </p>
          <div className="grid md:grid-cols-2 gap-4 md:gap-6 mb-6 md:mb-8" data-id="element-5898" data-mp="1nc4f78meqfrc">
            <div className="bg-white p-4 md:p-6 rounded-xl border border-slate-200 shadow-sm" data-id="element-5899" data-mp="1ne8hjm4nr6pi">
              <Monitor className="w-7 h-7 md:w-8 md:h-8 text-cyan-600 mb-3 md:mb-4" data-id="element-5900" data-mp="1iem71kg7s4ke" />
              <h4 className="font-bold text-slate-900 mb-1 md:mb-2 text-sm md:text-base" data-id="element-5901" data-mp="1dkrm6dovhjjq">
                Trabaja como siempre
              </h4>
              <p className="text-slate-600 text-xs md:text-sm" data-id="element-5902" data-mp="14lwh54xkefi0">
                Ves tu computadora normal, pero ahora con los Custom Lloyds
                guiándote paso a paso.
              </p>
            </div>
            <div className="bg-white p-4 md:p-6 rounded-xl border border-slate-200 shadow-sm" data-id="element-5903" data-mp="uo8bvl2c1pll">
              <Bot className="w-7 h-7 md:w-8 md:h-8 text-cyan-600 mb-3 md:mb-4" data-id="element-5904" data-mp="kk1rguso37uv" />
              <h4 className="font-bold text-slate-900 mb-1 md:mb-2 text-sm md:text-base" data-id="element-5905" data-mp="phtr6azjzy9m">
                Asistencia en tiempo real
              </h4>
              <p className="text-slate-600 text-xs md:text-sm" data-id="element-5906" data-mp="ui7nwwvpflsc">
                Los Custom Lloyds ven lo que tú ves y te dan instrucciones
                precisas para cada tarea.
              </p>
            </div>
          </div>

          <div className="bg-cyan-900/70 border border-cyan-500 rounded-xl p-4 md:p-6 mb-6" data-id="element-5907" data-mp="6rvaj6howwud">
            <h4 className="font-bold text-white mb-3 text-base md:text-lg flex items-center gap-2" data-id="element-5908" data-mp="bqyf6ptrd11t">
              <Check className="w-5 h-5 text-cyan-300" data-id="element-5909" data-mp="ghoi7weportc" />
              Precios de HeyLloyd (software mensual):
            </h4>
            <div className="space-y-2 text-white text-sm md:text-base" data-id="element-5910" data-mp="3f8glgstvu004">
              <div className="flex items-center gap-2" data-id="element-5911" data-mp="3k6rtqz4j42g8">
                <Check className="w-4 h-4 text-cyan-300 flex-shrink-0" data-id="element-5912" data-mp="3k56zlam4mliw" />
                <span data-id="element-5913" data-mp="3c5afxka6bmwp">
                  <strong className="text-cyan-100" data-id="element-5914" data-mp="3c4hhd6ldc3pn">Plan Anual:</strong> $20/mes
                  (facturado anualmente)
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-5915" data-mp="3lwesyegagxow">
                <Check className="w-4 h-4 text-cyan-300 flex-shrink-0" data-id="element-5916" data-mp="3lxyas9hlfgss" />
                <span data-id="element-5917" data-mp="3gy3jw5xtir7q">
                  <strong className="text-cyan-100" data-id="element-5918" data-mp="3gyvh1l72cx04">Plan Mensual:</strong>{' '}
                  $40/mes (facturado mensualmente)
                </span>
              </div>
            </div>
          </div>

          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 md:p-6 rounded-r-lg" data-id="element-5919" data-mp="2oa7ttk2r7xjx">
            <p className="font-bold text-slate-900 mb-2 flex items-center gap-2" data-id="element-5920" data-mp="333awymflm8r4">
              <Clock className="w-5 h-5 text-yellow-600" data-id="element-5921" data-mp="2y4pzgurqe36d" />
              ¿Por qué 48 horas?
            </p>
            <p className="text-slate-700 text-sm md:text-base" data-id="element-5922" data-mp="idbuutl8itwf">
              Porque los Custom Lloyds eliminan la curva de aprendizaje. No
              necesitas saber de tecnología, diseño o marketing. El sistema te
              dice exactamente qué hacer en cada momento, permitiéndote
              completar en 48 horas lo que normalmente tomaría semanas o meses.
            </p>
          </div>
        </StepSection>
      </div>

      {/* PASO 3 */}
      <div id="paso-3" data-id="element-5923" data-mp="fzq6451dqu7q">
        <StepSection stepNumber="3" title="Usa los Custom Lloyds especializados" data-id="element-5924" data-mp="g19pi4ic1ldq">
          <p className="text-slate-800 mb-4 md:mb-6 text-sm md:text-base" data-id="element-5925" data-mp="13r3xa7nsojr4">
            Cada <strong data-id="element-5926" data-mp="18poxw86yl5g3">Custom Lloyd</strong> es un bot especializado que te
            guía en una tarea específica del proceso. Desde crear tu producto
            hasta escribir el copy de ventas, cada Lloyd está pre-configurado
            para llevarte de la mano.
          </p>
          <div className="bg-slate-50 rounded-xl p-4 md:p-6 border border-slate-200 mb-6 md:mb-8" data-id="element-5927" data-mp="1moyh7gqgofoa">
            <h4 className="font-bold text-slate-900 mb-3 md:mb-4 text-sm md:text-base" data-id="element-5928" data-mp="1rfn7isqen6lu">
              Cómo funciona el sistema:
            </h4>
            <ol className="list-decimal list-inside space-y-2 text-slate-800 text-sm md:text-base" data-id="element-5929" data-mp="3s4u51i32pcf">
              <li data-id="element-5930" data-mp="3uwv63njjszda">Seleccionas el Lloyd que necesitas para tu tarea actual</li>
              <li data-id="element-5931" data-mp="3pxrzvzru0n3q">HeyLloyd carga ese bot especializado</li>
              <li data-id="element-5932" data-mp="3q0d3ouboxd44">
                Sigues las instrucciones paso a paso que aparecen en tu pantalla
              </li>
              <li data-id="element-5933" data-mp="mhjusutuxcga">Completas la tarea y pasas al siguiente Lloyd</li>
            </ol>
          </div>
          <div className="space-y-2" data-id="element-5934" data-mp="hj07apzm7slt">
            <h4 className="font-bold text-slate-900 text-sm md:text-base" data-id="element-5935" data-mp="hk1j4woggj4l">
              Todo está diseñado para que:
            </h4>
            <ul className="space-y-2 text-slate-800 text-sm md:text-base" data-id="element-5936" data-mp="cpxdcgqxeh53">
              <li className="flex items-center" data-id="element-5937" data-mp="8pwvsn8j5ptt">
                <span className="w-1.5 h-1.5 bg-cyan-400 rounded-full mr-2" data-id="element-5938" data-mp="1582nruiijfeq" />
                No necesites conocimientos técnicos previos
              </li>
              <li className="flex items-center" data-id="element-5939" data-mp="10gb3u2tv47xk">
                <span className="w-1.5 h-1.5 bg-cyan-400 rounded-full mr-2" data-id="element-5940" data-mp="2j4vsj4rommk6" />
                No tengas que pensar en qué hacer después
              </li>
              <li className="flex items-center" data-id="element-5941" data-mp="2o3p6eyavsfkv">
                <span className="w-1.5 h-1.5 bg-cyan-400 rounded-full mr-2" data-id="element-5942" data-mp="2s4raptjnnhtp" />
                Puedas completar todo el proceso en 48 horas o menos
              </li>
            </ul>
          </div>
        </StepSection>
      </div>

      {/* GALLERY - Custom Lloyds incluidos */}
      <section id="gallery" className="py-12 md:py-20 bg-slate-50 border-t border-slate-200" data-id="element-5943" data-mp="372b7weab88pb">
        <div className="container mx-auto px-4 max-w-6xl" data-id="element-5944" data-mp="3bt005vttd9pi">
          <div className="text-center mb-10 md:mb-16" data-id="element-5945" data-mp="3btjjngz4465n">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-slate-900 mb-3 md:mb-4 px-2" data-id="element-5946" data-mp="3fv4tsuk9i6c5">
              Custom Lloyds Incluidos en 48/hrs AI Cash Machine
            </h2>
            <p className="text-slate-800 max-w-2xl mx-auto text-sm md:text-base px-2" data-id="element-5947" data-mp="3pssr9s995ry0">
              Todos estos Custom Lloyds especializados están incluidos y listos
              para guiarte en cada paso del proceso
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8 mb-8 md:mb-12" data-id="element-5948" data-mp="1kt1ekvyw86fi">
            <LloydCard title="AI Product Builder" subtitle="Construcción de productos con IA" description="Tu asistente completo para crear productos digitales desde cero. HeyLloyd te guía en cada paso: desde la idea inicial hasta el lanzamiento, ayudándote a construir productos profesionales sin experiencia técnica." imageSrc="https://cdn.magicpatterns.com/uploads/pXDmn28qLnCMrUYkdpGPpS/hf_20260116_225721_4dc7f3c1-48e8-4206-b7a5-3ddf70d36f02.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="Obtener Acceso Ahora" buttonIcon="download" badge="INCLUIDO" data-id="element-5949" data-mp="1zh4k6490xg3s" />
            <LloydCard title="Ebook Writer" subtitle="Escritura de ebooks" description="Perfecto para crear ebooks completos desde cero. HeyLloyd te guiará en la estructura, capítulos, y contenido para que escribas tu ebook paso a paso, directamente en tu pantalla." imageSrc="https://cdn.magicpatterns.com/uploads/mZHQRarDkUFPHSnnRgrYNx/heylloyd-image-1768596398723.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="Obtener Acceso Ahora" buttonIcon="download" badge="INCLUIDO" data-id="element-5950" data-mp="o28za0jsaies" />
            <LloydCard title="Ebook Cover Designer" subtitle="Diseño de portadas" description="Especializado en crear portadas profesionales y atractivas para tus ebooks. HeyLloyd te guía en el diseño visual, tipografía y elementos gráficos para que tu ebook destaque y atraiga lectores." imageSrc="https://cdn.magicpatterns.com/uploads/95YcbtScePy8FYnqxtUWrb/hf_20260116_225742_c84c2966-04d0-407a-8eb3-53f8e6f29bab.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="Obtener Acceso Ahora" buttonIcon="download" badge="INCLUIDO" data-id="element-5951" data-mp="2px5cg5t5trwd" />
            <LloydCard title="Identity Persuasion Copywriter" subtitle="Copy persuasivo" description="Especializado en crear copy que conecta con la identidad de tu audiencia. Ideal para escribir mensajes que persuaden, venden y generan conversiones con técnicas de copywriting avanzadas." imageSrc="https://cdn.magicpatterns.com/uploads/mSU1vsY4XXAQMJDxHLq9tK/heylloyd-image-1768596505790.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="Obtener Acceso Ahora" buttonIcon="download" badge="INCLUIDO" data-id="element-5952" data-mp="590p19jh58xb" />
            <LloydCard title="Sales Letter Weapon" subtitle="Cartas de ventas" description="Tu arma secreta para crear sales letters que convierten. HeyLloyd te ayudará a estructurar y escribir cartas de ventas persuasivas que generan resultados reales." imageSrc="https://cdn.magicpatterns.com/uploads/5Vbgxv8pJwQBoVv72Jwat3/heylloyd-image-1768596561791.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="Obtener Acceso Ahora" buttonIcon="download" badge="INCLUIDO" data-id="element-5953" data-mp="25i3uaohsp50x" />
            <LloydCard title="Meta Ads Decision Engine" subtitle="Optimización de anuncios" description="Motor de decisiones para tus campañas de Meta Ads. HeyLloyd te ayuda a analizar, optimizar y tomar decisiones estratégicas sobre tus anuncios de Facebook e Instagram en tiempo real." imageSrc="https://cdn.magicpatterns.com/uploads/uX7GKZjLzcZHYruWJanCH7/heylloyd-image-1768596648758.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="Obtener Acceso Ahora" buttonIcon="download" badge="INCLUIDO" data-id="element-5954" data-mp="3lvbz0pqygyyf" />
            <LloydCard title="The Viral PDF Lab" subtitle="PDFs virales" description="Laboratorio especializado en crear PDFs que se comparten masivamente. Ideal para lead magnets, recursos descargables y contenido que tu audiencia querrá compartir una y otra vez." imageSrc="https://cdn.magicpatterns.com/uploads/wRK7DAN3h4pP5mk1SskSzS/heylloyd-image-1768596692126.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="Obtener Acceso Ahora" buttonIcon="download" badge="INCLUIDO" data-id="element-5955" data-mp="3fek5yz3jti5w" />
            <LloydCard title="AI Complete Brand Operation System" subtitle="Sistema de marca completo" description="Sistema operativo completo para tu marca con IA. Desde estrategia hasta ejecución, HeyLloyd te guía en todos los aspectos de construcción y operación de tu marca de forma integrada." imageSrc="https://cdn.magicpatterns.com/uploads/i1MwR9sTfLGqX1o8cqMy9E/heylloyd-image-1768596733993.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="Obtener Acceso Ahora" buttonIcon="download" badge="INCLUIDO" data-id="element-5956" data-mp="2f12eyejlp3pm" />
          </div>
          <div className="text-center bg-gradient-to-r from-cyan-50 to-blue-50 p-6 md:p-8 rounded-xl border-2 border-cyan-200 max-w-3xl mx-auto shadow-lg" data-id="element-5957" data-mp="2135cx2mdo53k">
            <h4 className="font-bold text-slate-900 mb-3 text-xl flex items-center justify-center gap-2" data-id="element-5958" data-mp="2a1zfd9me3pp1">
              <Zap className="w-6 h-6 text-yellow-500" data-id="element-5959" data-mp="3ggrsz7wiwad1" />
              Todos los Custom Lloyds incluidos en 48/hrs AI Cash Machine
            </h4>
            <p className="text-slate-800 mb-4" data-id="element-5960" data-mp="3lipj8m3cc5fh">
              Obtienes acceso instantáneo a todos estos Custom Lloyds
              especializados y el sistema paso a paso completo. Los Custom
              Lloyds se ejecutan en HeyLloyd (software mensual separado: $20/mes
              anual o $40/mes mensual).
            </p>
            <a href="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" target="_blank" rel="noopener noreferrer" data-id="element-5961" data-mp="3hty4rg1cucxw">
              <Button variant="cyan" size="lg" className="w-full md:w-auto shadow-xl" leftIcon={<ShoppingCart className="w-5 h-5" data-id="element-5963" data-mp="37uz2qgb3hfjv" />} data-id="element-5962" data-mp="3cv4ndciy61sg">
                Obtener Acceso a Todos los Custom Lloyds
              </Button>
            </a>
          </div>
        </div>
      </section>

      <DecisionGuide data-id="element-5964" data-mp="2yv2e2eopggot" />

      {/* FAQ Section */}
      <section className="py-12 md:py-20 bg-white" data-id="element-5965" data-mp="2ywn5hvfq3jig">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-5966" data-mp="1152fs1xnmg0q">
          <div className="text-center mb-10 md:mb-16" data-id="element-5967" data-mp="112g69wr7dqfv">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-5968" data-mp="x4iimyd2zcel">
              Preguntas Frecuentes
            </h2>
            <p className="text-lg text-slate-800" data-id="element-5969" data-mp="2qjtlwlem4edx">
              Encuentra respuestas a las preguntas más comunes sobre 48/hrs AI
              Cash Machine
            </p>
          </div>

          {/* Community & Support Highlight */}
          <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-5970" data-mp="2lmbjldv3oxew">
            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-xl p-6 border border-blue-200" data-id="element-5971" data-mp="2lkqqztscjojo">
              <div className="flex items-center gap-3 mb-3" data-id="element-5972" data-mp="39al3ga8r7b3e">
                <div className="bg-blue-500 rounded-full p-2" data-id="element-5973" data-mp="3eayz0st64skj">
                  <Users className="w-6 h-6 text-white" data-id="element-5974" data-mp="30c93vipwt2yt" />
                </div>
                <h3 className="font-bold text-slate-900 text-lg" data-id="element-5975" data-mp="35asnhch162o0">
                  Grupo Privado de Facebook
                </h3>
              </div>
              <p className="text-slate-700 text-sm" data-id="element-5976" data-mp="1ovriqerrimrh">
                Acceso exclusivo a nuestra comunidad privada donde puedes
                conectar con otros miembros, compartir experiencias y recibir
                apoyo constante.
              </p>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl p-6 border border-purple-200" data-id="element-5977" data-mp="1hdt9mbdhtdos">
              <div className="flex items-center gap-3 mb-3" data-id="element-5978" data-mp="1vbrn7ejzp638">
                <div className="bg-purple-500 rounded-full p-2" data-id="element-5979" data-mp="1qdzjln9zfvj7">
                  <Video className="w-6 h-6 text-white" data-id="element-5980" data-mp="1qeizyzjzibv4" />
                </div>
                <h3 className="font-bold text-slate-900 text-lg" data-id="element-5981" data-mp="12ox5uqigymtz">
                  Llamadas Mensuales en Vivo
                </h3>
              </div>
              <p className="text-slate-700 text-sm" data-id="element-5982" data-mp="1cdylugp0l47y">
                Cada mes, un lunes, Gabriel Beltran realiza una sesión en vivo
                para ayudarte a escalar tu negocio y responder tus preguntas.
              </p>
            </div>
          </div>

          <div className="space-y-4" data-id="element-5983" data-mp="jvt8au24rpu3">
            {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-md border border-slate-200 overflow-hidden transition-all duration-300 hover:shadow-lg" data-id="element-5984" data-mp="ezcjdxn3x7fy" data-mpi={index}>
                <button onClick={() => toggleFaq(index)} className="w-full px-6 py-5 text-left flex items-center justify-between gap-4 transition-colors duration-200 hover:bg-slate-50" data-id="element-5985" data-mp="3eaqvezfngfsc">
                  <span className="text-lg font-semibold text-slate-900 pr-4" data-id="element-5986" data-mp="3nb5k88rtod0l">
                    {faq.question}
                  </span>
                  <ChevronDown className={`w-6 h-6 text-cyan-600 flex-shrink-0 transition-transform duration-300 ${openFaqIndex === index ? 'rotate-180' : ''}`} data-id="element-5987" data-mp="y7163wzkkt1" />
                </button>
                <div className={`transition-all duration-300 ease-in-out ${openFaqIndex === index ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'} overflow-hidden`} data-id="element-5988" data-mp="aw4mojngo3hy">
                  <div className="px-6 pb-5 pt-2" data-id="element-5989" data-mp="evcbig3qg5u3">
                    <p className="text-slate-700 leading-relaxed" data-id="element-5990" data-mp="2cnzrcfbav7qo">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="mt-12 text-center bg-gradient-to-r from-cyan-50 to-blue-50 p-6 rounded-xl border border-cyan-200" data-id="element-5991" data-mp="296c3swxb2xny">
            <p className="text-slate-800 mb-4" data-id="element-5992" data-mp="24d98okcvrg5n">
              ¿Tienes más preguntas? Contáctanos directamente:
            </p>
            <a href="mailto:support@truemarketer.com" className="text-cyan-600 hover:text-cyan-700 font-semibold underline" data-id="element-5993" data-mp="1vdvy1od0sljc">
              support@truemarketer.com
            </a>
          </div>
        </div>
      </section>

      {/* Book a Call Section */}
      <section className="py-12 md:py-20 bg-gradient-to-b from-white to-slate-50" data-id="element-5994" data-mp="2n6d2q6u0fv0s">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-5995" data-mp="2j2f7w8bpx6dj">
          <div className="bg-gradient-to-r from-cyan-500 to-blue-500 rounded-xl p-8 md:p-12 text-center shadow-2xl" data-id="element-5996" data-mp="2e4dmvhuqewzf">
            <Calendar className="w-12 h-12 md:w-16 md:h-16 text-white mx-auto mb-6" data-id="element-5997" data-mp="17oum3r4zas9b" />
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-white mb-4" data-id="element-5998" data-mp="12phyh46a9h5o">
              ¿Necesitas Ayuda Para Empezar?
            </h2>
            <p className="text-lg md:text-xl text-white/90 mb-8 max-w-2xl mx-auto" data-id="element-5999" data-mp="146x52b6qdsw5">
              Duración: 20-30 minutos
              <br data-id="element-6000" data-mp="193e0zrk69bjs" />
              <br data-id="element-6001" data-mp="v5pfchia60do" />
              Tiempo suficiente para conocerte
            </p>
            <a href="https://api.leadconnectorhq.com/widget/bookings/info-commerce-llamada-de-claridad-crea-tu-producto-digital-con-ia" target="_blank" rel="noopener noreferrer" className="inline-block bg-white text-cyan-600 px-8 md:px-12 py-4 md:py-5 rounded-full font-bold text-lg md:text-xl hover:bg-gray-50 hover:scale-105 transition-all duration-300 shadow-xl" data-id="element-6002" data-mp="v81xauo1gaqq">
              Reservar Llamada de Claridad
            </a>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-12 md:py-20 bg-gradient-to-b from-white to-cyan-50" data-id="element-6003" data-mp="gegjvrrp5ksm">
        <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-6004" data-mp="2htldkk3imkl">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-slate-900 mb-6" data-id="element-6005" data-mp="7etiv72vqh03">
            Empieza tu 48/hrs AI Cash Machine hoy
          </h2>
          <p className="text-xl text-slate-800 mb-8 max-w-2xl mx-auto" data-id="element-6006" data-mp="3f0mdu78fa8k8">
            Acceso inmediato a HeyLloyd y todos los Custom Lloyds. Comienza a
            construir tu producto digital ahora mismo.
          </p>
          <a href="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" target="_blank" rel="noopener noreferrer" data-id="element-6007" data-mp="3oyaflh4g4gbw">
            <Button variant="cyan" size="lg" className="w-full md:w-auto shadow-2xl text-xl py-6 px-12" leftIcon={<ShoppingCart className="w-6 h-6" data-id="element-6009" data-mp="1tb5puxyk8uv" />} data-id="element-6008" data-mp="6rw4rr1h4mhq">
              Comprar Ahora - Acceso Instantáneo
            </Button>
          </a>
          <p className="text-sm text-slate-500 mt-4" data-id="element-6010" data-mp="gkthfgjsbh8f">
            Garantía de satisfacción de 30 días
          </p>
        </div>
      </section>

      {/* Footer */}
      <Footer data-id="element-6011" data-mp="pkggvwsyecyu" />

      {/* Terms Modal */}
      {showTerms && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowTerms(false)} data-id="element-6012" data-mp="kkvlfwczsmqv">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative" onClick={e => e.stopPropagation()} data-id="element-6013" data-mp="1rvzvlgg24c94">
            <button onClick={() => setShowTerms(false)} className="absolute top-4 right-4 text-gray-300 hover:text-white transition-colors" data-id="element-6014" data-mp="20xput8g6kfhg">
              <X className="w-6 h-6" data-id="element-6015" data-mp="25vrf1wpcekui" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white" data-id="element-6016" data-mp="196jsqmgwg7pj">
              Términos y Condiciones
            </h2>
            <div className="text-gray-200 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-6017" data-mp="1d7dh1gy97oiy">
              <p data-id="element-6018" data-mp="1i6q3w1p4kvlj">
                Al adquirir 48/hrs AI Cash Machine, aceptas los siguientes
                términos y condiciones:
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-6019" data-mp="1n019y0m458ce">
                1. Aceptación de Términos
              </h3>
              <p data-id="element-6020" data-mp="uhnicirdeilr">
                Al acceder y utilizar este producto, aceptas estar sujeto a
                estos términos y condiciones, todas las leyes y regulaciones
                aplicables.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-6021" data-mp="hyjn50dy4kii">
                2. Uso del Servicio
              </h3>
              <p data-id="element-6022" data-mp="cyx9ipu7h296">
                El contenido proporcionado es solo para fines educativos e
                informativos. No garantizamos resultados específicos de ingresos
                o éxito comercial.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-6023" data-mp="40l9xybd2u4l">
                3. Propiedad Intelectual
              </h3>
              <p data-id="element-6024" data-mp="3qeuu1v89dfzk">
                Todo el contenido, materiales, y recursos proporcionados son
                propiedad de 48 Hrs AI Cash Machine y están protegidos por
                derechos de autor. No está permitida la reproducción o
                distribución sin autorización expresa.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-6025" data-mp="3cfc1iarxkd8d">
                4. Limitación de Responsabilidad
              </h3>
              <p data-id="element-6026" data-mp="2lbzdssxfmedu">
                48 Hrs AI Cash Machine no será responsable de ningún daño
                directo, indirecto, incidental o consecuente que resulte del uso
                o la imposibilidad de usar nuestros servicios.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-6027" data-mp="2qcdmmd6uxscx">Contacto</h3>
              <p data-id="element-6028" data-mp="2qaan92jtemvj">
                Para preguntas sobre estos términos, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-cyan-400 hover:text-cyan-300" data-id="element-6029" data-mp="22n2j4ny4hjv3">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}

      {/* Privacy Modal */}
      {showPrivacy && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowPrivacy(false)} data-id="element-6030" data-mp="27kujm6cu2eaw">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative" onClick={e => e.stopPropagation()} data-id="element-6031" data-mp="1ju6zmmpn7y7z">
            <button onClick={() => setShowPrivacy(false)} className="absolute top-4 right-4 text-gray-300 hover:text-white transition-colors" data-id="element-6032" data-mp="3qkaa9i1p3g61">
              <X className="w-6 h-6" data-id="element-6033" data-mp="3vcleuy7drq4x" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white" data-id="element-6034" data-mp="3gn5pnmnhzsrc">
              Política de Privacidad
            </h2>
            <div className="text-gray-200 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-6035" data-mp="3llqobhn3q4do">
              <p data-id="element-6036" data-mp="d6704x1afc5h">
                En 48 Hrs AI Cash Machine, nos comprometemos a proteger tu
                privacidad. Esta política describe cómo recopilamos, usamos y
                protegemos tu información personal.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-6037" data-mp="86kjseq5xfsg">
                1. Información que Recopilamos
              </h3>
              <p data-id="element-6038" data-mp="2ouyg166etgmg">
                Recopilamos información que nos proporcionas directamente,
                incluyendo información de compra y comunicaciones.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-6039" data-mp="zdt6nqkmazqm">
                2. Uso de la Información
              </h3>
              <p data-id="element-6040" data-mp="ug13g0eivr74">
                Utilizamos tu información para proporcionar acceso al producto y
                soporte.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-6041" data-mp="pm6lp2ih9mao">
                3. Seguridad de Datos
              </h3>
              <p data-id="element-6042" data-mp="gnl5vf4e4ldl">
                Implementamos medidas de seguridad apropiadas para proteger tu
                información personal.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-6043" data-mp="bmx88alnp6ae">Contacto</h3>
              <p data-id="element-6044" data-mp="6qgk3gegirxb">
                Para preguntas sobre esta política de privacidad, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-cyan-400 hover:text-cyan-300" data-id="element-6045" data-mp="1rdqcs3xg84n">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}

      {/* Floating WhatsApp Button */}
      <WhatsAppButton data-id="element-6046" data-mp="24llzuz3swn1e" />
    </div>;
}